// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page .admin-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    min-width: none;
    padding: 50px;
    border-radius: 5px;
    transition: 0.2s;
    background-color: #ffffff;
    position: relative;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1), 2px 0px 36px rgba(0, 0, 0, 0.07);
  }

    .admin-page .admin-form__secondary {
      text-align: center;
    }

    .admin-page .admin-form__to-home-container {
      width: 64px;
      height: 64px;
      margin-bottom: 24px;
    }

    .admin-page .admin-form__to-home-container__icon {
        font-size: 32px;
        color: #ffffff;
      }

    .admin-page .admin-form__filled {
      width: 100%;
    }

    .admin-page .admin-form__btn {
      border: none;
      min-width: 80px;
      background: #5179ff;
      align-self: center;
    }

    .admin-page .admin-form__btn:hover {
        border: 1px solid #6387ff;
        color: #f6f9fb;
        background: #6387ff;
      }
`, "",{"version":3,"sources":["webpack://./src/components/Auth/AdminForm/style.scss"],"names":[],"mappings":"AAGE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,6EAAuB;EAiCzB;;IA/BE;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IAMrB;;IAJE;QACE,eAAe;QACf,cAAa;MACf;;IAGF;MACE,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,eAAe;MACf,mBAAyB;MACzB,kBAAkB;IAOpB;;IALE;QACE,yBAA+B;QAC/B,cAAmB;QACnB,mBAAyB;MAC3B","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\n.admin-page {\n  .admin-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: 400px;\n    min-width: none;\n    padding: 50px;\n    border-radius: 5px;\n    transition: 0.2s;\n    background-color: #ffffff;\n    position: relative;\n    box-shadow: $box-shadow;\n\n    &__secondary {\n      text-align: center;\n    }\n\n    &__to-home-container {\n      width: 64px;\n      height: 64px;\n      margin-bottom: 24px;\n\n      &__icon {\n        font-size: 32px;\n        color: $white;\n      }\n    }\n\n    &__filled {\n      width: 100%;\n    }\n\n    &__btn {\n      border: none;\n      min-width: 80px;\n      background: $blue-default;\n      align-self: center;\n\n      &:hover {\n        border: 1px solid $blue-hovered;\n        color: $white-light;\n        background: $blue-hovered;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
